const getAllowed = () => {
  const ls = localStorage.getItem('cookies');
  return ls ? ls.split(',') : [];
};

const useGAEventsTracker = (category = 'Event Category') => {
  return (action = 'action', label = 'label', extra = {}) => {
    if (!getAllowed().includes('analysis')) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'custom_event',
      event_category: category,
      event_action: action,
      event_label: label,
      ...extra,
    });
  };
};

export default useGAEventsTracker;
